import { render, staticRenderFns } from "./SendContract.vue?vue&type=template&id=290bc904"
import script from "./SendContract.vue?vue&type=script&lang=js"
export * from "./SendContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports